export default {"src":"/_next/static/media/California.cd3bd94a.svg","height":142,"width":229,"blurWidth":0,"blurHeight":0};